import * as ConstellationIcons from '@zillow/constellation-icons';
import { IconBuildingOutline } from '@zillow/constellation-icons';
import type { ComponentType, ForwardRefExoticComponent, RefAttributes, SVGProps } from 'react';

type IconComponent =
  | ComponentType<SVGProps<SVGSVGElement>>
  | ForwardRefExoticComponent<Omit<SVGProps<SVGSVGElement>, 'ref'> & RefAttributes<SVGSVGElement>>;

export type IconLookupOptions = {
  iconName: string | null | undefined;
  fallbackIcon?: IconComponent;
};

/**
 * Dynamically looks up a Constellation icon by name using direct barrel import.
 *
 * Use this for components with v10Icon fields from the backend.
 *
 * @param iconName - The exact Constellation v10 icon name (e.g., "IconHomesFilled")
 * @param fallbackIcon - Optional fallback icon if lookup fails
 * @returns The icon component or fallback
 */
export const getConstellationIcon = ({
  iconName,
  fallbackIcon = IconBuildingOutline,
}: IconLookupOptions): IconComponent => {
  if (!iconName || iconName.trim() === '') {
    return fallbackIcon;
  }

  const IconComponent = (ConstellationIcons as Record<string, IconComponent>)[iconName];
  return IconComponent || fallbackIcon;
};
